<div *ngFor="let breadcrumb of breadcrumbs">
    <ol class="page-container__breadcrumb">
        <li><a href="/">Home</a></li>
        <li class="page-container__breadcrumb--item" [routerLink]="breadcrumb.url" routerLinkActive="router-link-active">{{ breadcrumb.label | translate }}</li>
    </ol>
</div>
